import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "hero-body" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "columns is-centered" }
const _hoisted_4 = {
  class: "column is-6-tablet is-5-desktop is-4-widescreen",
  style: {"margin-top":"10%"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "is-size-4 has-text-centered" }, "Reset password", -1)
const _hoisted_6 = { class: "field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "New password", -1)
const _hoisted_8 = { class: "control has-icons-left" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-envelope" })
], -1)
const _hoisted_10 = { class: "field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Confirm new password", -1)
const _hoisted_12 = { class: "control has-icons-left" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-lock" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "field" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "button is-info" }, "Update password")
], -1)
const _hoisted_15 = {
  key: 0,
  class: "message is-danger"
}
const _hoisted_16 = { class: "message-body" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("article", { class: "message is-success" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "message-body" }, " Password has been updated! ")
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "field" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/login.html" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-left" })
    ]),
    /*#__PURE__*/_createTextVNode(" back to login form ")
  ]),
  /*#__PURE__*/_createElementVNode("br")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (!_ctx.changed)
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  class: "box",
                  onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)), ["prevent"]))
                }, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
                        type: "password",
                        placeholder: "",
                        autocomplete: "off",
                        class: "input",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.password]
                      ]),
                      _hoisted_9
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password1) = $event)),
                        type: "password",
                        placeholder: "",
                        autocomplete: "off",
                        class: "input",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.password1]
                      ]),
                      _hoisted_13
                    ])
                  ]),
                  _hoisted_14,
                  (_ctx.errors)
                    ? (_openBlock(), _createElementBlock("article", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.errors), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 32))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19)),
            _hoisted_20
          ])
        ])
      ])
    ])
  ]))
}